import React from 'react'
import { Button } from 'react-bootstrap'

import useAppContext from '../../app'
import useContainerContext from '../../containerContext'
import Filter from './Filter'
import ReportTable from './ReportTable'
import Paging from '../../paging'
import './adasReports.css'

const AdasReports = ({ onUpload }) => {
  const { store: { clientSettings } } = useAppContext()

  const allowUpload = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowUpload
  // Company must have an active adasThink subscription or gift credits to submit.
  const hasAdasCredits = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.hasAdasCredits

  const {
    setState,
    state: { query },
    total,
  } = useContainerContext()

  const onPaging = ({ skip, limit }) => {
    const page = Math.floor(skip / limit) + 1
    setState(prev => ({
      ...prev,
      query: { ...prev.query, page, limit },
    }))
  }

  return (
    <div className='adas-page my-5'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h5 className='mb-0'>ADAS Reports</h5>
        {allowUpload && (
          <Button
            variant='primary'
            style={{ padding: '8px 16px' }}
            onClick={onUpload}
            disabled={!hasAdasCredits}
            title={!hasAdasCredits ? 'No ADAS credits available — an active subscription or gift credits are required.' : undefined}
          >
            NEW REPORT
          </Button>
        )}
      </div>

      <Filter />
      <ReportTable />

      <Paging
        skip={(query.page - 1) * query.limit}
        limit={query.limit}
        total={total}
        onChange={onPaging}
      />
    </div>
  )
}

export default AdasReports
